// assets/discount-drawer.js
(function () {
  // Empêcher le double-binding
  if (window.__KEA_PROMO_BOUND__) return;

  // Récupérer le cart-drawer et sa config
  const drawer = document.getElementById("mini-cart") || document.querySelector("cart-drawer");
  if (!drawer) return;

  const promoEnabled = String(drawer.dataset.promoEnabled || "").toLowerCase() === "true";
  if (!promoEnabled) return;

  // On peut maintenant considérer le script comme lié
  window.__KEA_PROMO_BOUND__ = true;

  // Codes déclencheurs depuis data-promo-code='["XXX25","YYY25"]'
  let codes = [];
  try {
    if (drawer.dataset.promoCode) {
      codes = JSON.parse(drawer.dataset.promoCode);
    }
  } catch (e) {
    console.warn("[discount-drawer] unable to parse data-promo-code", e);
  }

  const variantIdAttr = drawer.dataset.promoVariantId;
  const promoVariantId = variantIdAttr ? Number(variantIdAttr) : 0;

  // ========= CONFIG =========
  // Map code promo -> id de variante cadeau
  const PROMO_MAP = {};
  if (codes.length && promoVariantId) {
    codes.forEach((code) => {
      if (!code) return;
      PROMO_MAP[String(code).toUpperCase()] = promoVariantId;
    });
  }
  const TRIGGER_CODES = Object.keys(PROMO_MAP); // peut être []

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const JSON_HEADERS = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  // ========= HELPERS AJAX CART =========

  const cartGet = () =>
    fetch(ROOT + "cart.js", { credentials: "same-origin" }).then((r) => r.json());

  // Applique une liste de codes sous forme CSV ("CODE1,CODE2")
  async function applyCodes(csv) {
    let res = await fetch(ROOT + "cart/update.js", {
      method: "POST",
      headers: JSON_HEADERS,
      credentials: "same-origin",
      body: JSON.stringify({ discount: csv }), // API discount param
    });

    if (!res.ok) {
      // fallback form-encoded si le thème / proxy exige un form classique
      res = await fetch(ROOT + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: "discount=" + encodeURIComponent(csv),
      });
    }

    console.log("[discount-drawer] applyCodes:", csv, "status", res.status);
    return res.ok;
  }

  async function addVariant(variantId, props) {
    if (!variantId) return;

    const body = {
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: props || { _promo_code: "BXGY" },
        },
      ],
    };

    const res = await fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: JSON_HEADERS,
      credentials: "same-origin",
      body: JSON.stringify(body),
    });

    console.log("[discount-drawer] /cart/add.js status", res.status, "for variant", variantId);

    if (!res.ok) {
      try {
        const data = await res.json();
        console.warn("[discount-drawer] add error payload", data);
      } catch (e) {
        console.warn("[discount-drawer] add error", e);
      }
    }
  }

  async function changeByKey(key, quantity) {
    const res = await fetch(ROOT + "cart/change.js", {
      method: "POST",
      headers: JSON_HEADERS,
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity }),
    });
    console.log(
      "[discount-drawer] /cart/change.js status",
      res.status,
      "key",
      key,
      "qty",
      quantity,
    );
  }

  // ========= REFRESH DU DRAWER =========

  async function refreshDrawer() {
    // 1) Hook Focal / thème : event custom
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));

    // 2) Fallback Section Rendering API (?sections=...)
    const sid = drawer.dataset.sectionId || drawer.getAttribute("section");
    if (!sid) return;

    const ids = [sid, "cart-icon-bubble"];

    try {
      const res = await fetch(`${ROOT}?sections=${ids.join(",")}`, {
        credentials: "same-origin",
      });
      if (!res.ok) return;
      const html = await res.json();

      ids.forEach((id) => {
        const host =
          document.getElementById("shopify-section-" + id) ||
          document.querySelector(`[data-section-id="${id}"]`);
        if (host && html[id]) {
          host.innerHTML = html[id];
        }
      });
    } catch (e) {
      console.warn("[discount-drawer] refreshDrawer error", e);
    }
  }

  // ========= LOGIQUE PRINCIPALE =========

  // ==== EFFET FEU D'ARTIFICE ====

  function keaFireworksAtElement(el) {
    if (!el || !el.getBoundingClientRect) return;

    const rect = el.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;

    const container = document.createElement("div");
    container.className = "kea-fireworks-container";
    container.style.position = "fixed";
    container.style.inset = "0";
    container.style.pointerEvents = "none";
    container.style.zIndex = "9999";
    container.style.overflow = "visible";
    document.body.appendChild(container);

    const colors = ["#ff6b6b", "#feca57", "#48dbfb", "#5f27cd", "#1dd1a1", "#ffffff"];
    const particleCount = 64;

    // Petit flash central
    const flash = document.createElement("div");
    flash.style.position = "absolute";
    flash.style.left = x + "px";
    flash.style.top = y + "px";
    flash.style.width = "24px";
    flash.style.height = "24px";
    flash.style.borderRadius = "999px";
    flash.style.background = "rgba(255,255,255,0.95)";
    flash.style.transform = "translate(-50%, -50%) scale(0)";
    flash.style.opacity = "0.9";
    flash.style.boxShadow = "0 0 40px rgba(255,255,255,0.9)";
    flash.style.transition = "transform 260ms ease-out, opacity 360ms ease-out";
    container.appendChild(flash);

    requestAnimationFrame(() => {
      flash.style.transform = "translate(-50%, -50%) scale(3.2)";
      flash.style.opacity = "0";
    });

    // Particules
    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement("span");
      particle.className = "kea-fireworks-particle";

      const angle = Math.random() * Math.PI * 2;
      const ring = Math.random() < 0.5 ? 1 : 2;
      const baseDistance = ring === 1 ? 90 : 150;
      const distance = baseDistance + Math.random() * 40;

      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance;

      particle.style.position = "absolute";
      particle.style.left = x + "px";
      particle.style.top = y + "px";
      particle.style.width = "10px";
      particle.style.height = "10px";
      particle.style.borderRadius = "999px";
      particle.style.backgroundColor = colors[i % colors.length];
      particle.style.opacity = "1";
      particle.style.transform = "translate(-50%, -50%) translate(0, 0)";
      particle.style.boxShadow = "0 0 14px rgba(0,0,0,0.25), 0 0 18px rgba(255,255,255,0.6)";
      particle.style.transition =
        "transform 1100ms cubic-bezier(0.16, 0.84, 0.44, 1), opacity 1100ms ease-out";

      container.appendChild(particle);

      // Lancer l’animation au frame suivant
      requestAnimationFrame(() => {
        // On ajoute un léger “gravity” vers le bas
        const gravity = 35 + Math.random() * 25;
        particle.style.transform = `translate(-50%, -50%) translate(${dx}px, ${dy + gravity}px)`;
        particle.style.opacity = "0";
      });
    }

    setTimeout(() => {
      container.remove();
    }, 1300);
  }

  // Soumission du formulaire de code promo dans le drawer
  document.addEventListener("submit", async (ev) => {
    const form = ev.target.closest("#drawer-discount-form");
    if (!form) return;

    ev.preventDefault();

    const input = form.querySelector("#drawer-discount-input");
    const feedback = document.getElementById("drawer-discount-feedback");
    const raw = (input?.value || "").trim();
    const code = raw.toUpperCase();

    if (!code) {
      if (feedback) {
        feedback.textContent = "Entrez un code";
        feedback.style.color = "#b42318";
      }
      return;
    }

    try {
      // 1) Appliquer le code côté panier
      await applyCodes(code);

      // 2) Si c'est un code qui doit ajouter un cadeau -> on ajoute la variante
      if (TRIGGER_CODES.includes(code)) {
        const variantId = PROMO_MAP[code];
        const cart = await cartGet();

        const already = (cart.items || []).some((li) => li.id === variantId);
        if (!already) {
          await addVariant(variantId, { _promo_code: code });
        }
      }

      if (feedback) {
        feedback.textContent = "Code appliqué";
        feedback.style.color = "";
      }
      if (input) input.value = "";

      // Effet feu d'artifice
      const applyButton = form.querySelector('button[type="submit"]');
      if (applyButton) {
        keaFireworksAtElement(applyButton);
      }

      // 3) Rafraîchir le drawer et la bulle
      await refreshDrawer();
    } catch (e) {
      if (feedback) {
        feedback.textContent = "Erreur, merci de réessayer.";
        feedback.style.color = "#b42318";
      }
      console.warn("[discount-drawer] error", e);
    }
  });

  // Clic sur la croix ✕ de suppression de code
  // Clic sur la croix ✕ de suppression de code
  document.addEventListener("click", async (ev) => {
    const btn = ev.target.closest('[data-action="remove-discount"]');
    if (!btn) return;

    const removed = (btn.dataset.code || "").toUpperCase();
    if (!removed) return;

    try {
      const cart = await cartGet();

      // 1) Supprimer tous les gifts marqués avec ce _promo_code
      const itemsToRemove = (cart.items || []).filter((li) => {
        if (!li.properties) return false;
        const prop =
          li.properties._promo_code ||
          li.properties["_promo_code"] || // suivant la forme du JSON
          "";
        return prop.toString().toUpperCase() === removed;
      });

      for (const item of itemsToRemove) {
        await changeByKey(item.key, 0);
      }

      // 2) Optionnel : clear les discounts “vrais” Shopify si jamais tu en ajoutes
      // (ici, comme tu n'en as pas, ça ne fera rien de grave)
      await applyCodes("");

      // 3) Rafraîchir le drawer et la bulle
      await refreshDrawer();
    } catch (e) {
      console.warn("[discount-drawer] remove error", e);
    }
  });
})();
